import { motion } from "framer-motion";
import { ArrowUpRight, Play } from "@phosphor-icons/react";

const EASE = [0.16, 1, 0.3, 1];

export default function CTASection() {
  return (
    <section data-testid="cta-section" className="relative bg-[#f6f6f7] text-[#0a0a0a] py-28 md:py-40 overflow-hidden border-t border-black/5">
      <div className="grain mix-blend-multiply opacity-[0.05]" aria-hidden="true" />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -left-20 -bottom-20 h-80 w-80 rounded-full border-[14px] border-[#f5d949]/40"
      />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease: EASE }}
        className="relative z-10 mx-auto max-w-[1100px] px-5 md:px-10 text-center"
      >
        <h2 className="font-display font-black tracking-[-0.03em] leading-[0.95] text-[clamp(2.5rem,7vw,6rem)]">
          Ready to simplify wallet deposits?
        </h2>
        <p className="mt-6 text-lg md:text-xl font-medium text-zinc-600 max-w-xl mx-auto">
          Move stablecoins between wallets with just a few taps.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <a
            href="https://app.opendeposit.xyz"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-launch-btn"
            className="group inline-flex items-center gap-2 rounded-full bg-[#0a0a0a] text-white font-bold px-8 py-4 text-base hover:bg-black/85 transition-colors"
          >
            Launch App
            <ArrowUpRight size={20} weight="bold" className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
          <button
            data-testid="cta-demo-btn"
            className="group inline-flex items-center gap-2 rounded-full border-2 border-black/25 font-bold px-8 py-4 text-base hover:bg-black/5 transition-colors"
          >
            <Play size={18} weight="fill" />
            Watch Demo
          </button>
        </div>
      </motion.div>
    </section>
  );
}
